import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {FaHeart, FaShoppingBag, FaTimes, FaCheck, FaStar} from 'react-icons/fa';
import {cardFloat, cardStagger} from "../animations/animations";


const WishlistGrid = ({
                          items,
                          onRemove,
                          onMoveToCart,
                          selectedItems = [],
                          onSelectItem
                      }) => {
    return (
        <motion.div
            variants={cardStagger}
            initial="initial"
            animate="animate"
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
            <AnimatePresence>
                {items.map((item, index) => (
                    <motion.div
                        key={item.id}
                        variants={cardFloat}
                        layout
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="luxury-card overflow-hidden group relative"
                    >
                        {/* Selection Checkbox */}
                        {onSelectItem && (
                            <button
                                onClick={() => onSelectItem(item.id)}
                                className={`absolute top-4 left-4 z-20 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
                                    selectedItems.includes(item.id)
                                        ? 'bg-champagne border-champagne'
                                        : 'bg-white/80 border-nude hover:border-champagne'
                                }`}
                            >
                                {selectedItems.includes(item.id) && (
                                    <FaCheck className="w-3 h-3 text-white" />
                                )}
                            </button>
                        )}

                        {/* Image */}
                        <div className="relative overflow-hidden">
                            <motion.img
                                src={item.image}
                                alt={item.name}
                                className="w-full h-64 object-cover"
                                whileHover={{ scale: 1.05 }}
                                transition={{ duration: 0.6 }}
                            />

                            {/* Stock Badge */}
                            {!item.inStock && (
                                <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 rounded-full text-sm text-charcoal/60">
                                    Out of Stock
                                </div>
                            )}

                            {/* Overlay Actions */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                                    <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        onClick={() => onMoveToCart(item.id)}
                                        disabled={!item.inStock}
                                        className={`flex-1 px-4 py-2 rounded-full flex items-center justify-center gap-2 font-medium transition-colors ${
                                            item.inStock
                                                ? 'bg-white text-charcoal hover:bg-champagne'
                                                : 'bg-white/50 text-charcoal/40 cursor-not-allowed'
                                        }`}
                                    >
                                        <FaShoppingBag className="w-4 h-4" />
                                        {item.inStock ? 'Add to Cart' : 'Notify Me'}
                                    </motion.button>

                                    <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        onClick={() => onRemove(item.id)}
                                        className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-charcoal/50 hover:text-error transition-colors"
                                    >
                                        <FaTimes className="w-4 h-4" />
                                    </motion.button>
                                </div>
                            </div>

                            {/* Heart Icon */}
                            <div className="absolute top-4 right-4">
                                <motion.div
                                    animate={{ scale: [1, 1.1, 1] }}
                                    transition={{ duration: 2, repeat: Infinity }}
                                    className="w-10 h-10 bg-white/90 rounded-full flex items-center justify-center"
                                >
                                    <FaHeart className="w-4 h-4 text-champagne" />
                                </motion.div>
                            </div>
                        </div>

                        {/* Product Info */}
                        <div className="p-4">
                            <p className="text-sm text-charcoal/50 mb-1">{item.category}</p>
                            <h4 className="font-medium text-charcoal mb-2 truncate">{item.name}</h4>
                            <p className="text-charcoal/60 text-sm mb-3">{item.variant}</p>

                            <div className="flex items-center justify-between">
                                <div className="flex items-baseline gap-2">
                                    <span className="text-xl font-light text-charcoal">${item.price.toFixed(2)}</span>
                                    {item.rating && (
                                        <div className="flex items-center gap-1">
                                            <FaStar className="w-3 h-3 text-champagne" />
                                            <span className="text-sm text-charcoal/50">{item.rating}</span>
                                        </div>
                                    )}
                                </div>

                                <motion.span
                                    className={`text-xs px-2 py-1 rounded-full ${
                                        item.inStock
                                            ? 'bg-sage/10 text-sage'
                                            : 'bg-nude/30 text-charcoal/60'
                                    }`}
                                    animate={item.inStock ? {
                                        backgroundColor: ['#9CAF961A', '#C8D6C21A', '#9CAF961A']
                                    } : {}}
                                    transition={{ duration: 4, repeat: Infinity }}
                                >
                                    {item.inStock ? 'In Stock' : 'Out of Stock'}
                                </motion.span>
                            </div>
                        </div>

                        {/* Selection Overlay */}
                        {selectedItems.includes(item.id) && (
                            <div className="absolute inset-0 bg-champagne/5 border-2 border-champagne/30 rounded-xl pointer-events-none" />
                        )}
                    </motion.div>
                ))}
            </AnimatePresence>
        </motion.div>
    );
};

export default WishlistGrid;